<template>
  <Transition name="panel-slide-fade" appear>
    <div ref="panelContainer"
      class="absolute right-3 bottom-3 left-3 sm:left-auto sm:w-96 lg:w-[28rem] z-70 flex flex-col overflow-hidden rounded-2xl border shadow-2xl dark:shadow-black/60 outline-none motion-reduce:transition-none"
      :class="plannedSignOut ? 'top-[89px]' : 'top-[60px]'"
      role="dialog"
      aria-modal="false"
      :aria-labelledby="titleId"
      tabindex="-1"
      @drop.prevent
      @dragover.prevent
      @dragenter.prevent
      @dragleave.prevent
    >
<!-- Frosted background as its own layer behind the content. A backdrop-filter on the panel itself would make it the
     containing block for position:fixed descendants, so popups that measure against the viewport (DateTimeField's picker,
     MultiSelectDropdown's list) would land off-panel and be clipped by overflow-hidden. -->
      <div aria-hidden="true" class="absolute inset-0 -z-10 rounded-2xl pointer-events-none bg-white dark:bg-neutral-950 supports-[(backdrop-filter:blur(1px))_or_(-webkit-backdrop-filter:blur(1px))]:bg-white/70 dark:supports-[(backdrop-filter:blur(1px))_or_(-webkit-backdrop-filter:blur(1px))]:bg-neutral-950/60 backdrop-blur-xl backdrop-saturate-150 dark:backdrop-saturate-[1.4]"></div>
<!-- Header -->
      <div class="w-full flex-shrink-0 flex flex-row items-center pt-[18px] pr-4 pb-4 pl-4">
          <div :id="titleId" class="flex-grow text-left text-sky whitespace-normal truncate mr-1 text-base font-semibold">
              {{title}}
          </div>
          <button class="bn-icon-only text-sky flex-shrink-0" aria-label="Close" @click="closePanel()" :disabled="isModalBlocked">
              <XIcon />
          </button>
      </div>
<!-- Body -->
      <div class="w-full flex flex-col flex-grow flex-auto h-0 overflow-y-auto pt-1 px-4 pb-6">
          <slot name="content" />
      </div>
    </div>
  </Transition>
</template>

<script>
import {XIcon} from "@heroicons/vue/outline"
import { inject,ref,onMounted,onUnmounted,nextTick } from 'vue'

let panelCount = 0

export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    components:{XIcon},
    emits:["closePanel"],
    setup (_,{emit}) {
        const global = inject('global')
        const {isModalBlocked, plannedSignOut} = global

    // Refs
        const panelContainer = ref(null)
        const titleId = `side-panel-title-${++panelCount}`
        let opener = null

    // Lifecycle
        onMounted(() => {
            opener = document.activeElement
            document.addEventListener('keydown', handleKeydown)
            nextTick(() => {
                panelContainer.value?.focus({ preventScroll: true })
            })
        })

        onUnmounted(() => {
            document.removeEventListener('keydown', handleKeydown)
            if (opener?.isConnected && typeof opener.focus === 'function') {
                opener.focus({ preventScroll: true })
            }
        })

    // Handlers
        const closePanel = ()=>{
            emit("closePanel")
        }

        const handleKeydown = (e) => {
            if (e.key !== 'Escape' || e.defaultPrevented || isModalBlocked?.value) return
            closePanel()
        }

        return {
            panelContainer,
            titleId,
            isModalBlocked,
            plannedSignOut,
            closePanel
        }
    }

}
</script>
